


















































































































































































































import Vue from "vue";
import moment from "moment";

import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { GetDataFlowKillServiceCommand } from "@/model/communication/dataFlow/GetDataFlowKillServiceCommand";
import { GetDataFlowPauseServiceCommand } from "@/model/communication/dataFlow/GetDataFlowPauseServiceCommand";
import { GetDataFlowResumeServiceCommand } from "@/model/communication/dataFlow/GetDataFlowResumeServiceCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    props: {
        metrics: Object,
        metricsLoadedAt: String,
    },
    data() {
        return {
            moment,
            metricsGranularity: 3,
            showKillDialog: false,
            showPauseDialog: false,
            showResumeDialog: false,
            loadingControlService: false,
            showControlServiceError: null,
            controlServiceError: null,
            killDialogServiceName: null,
            pauseDialogServiceName: null,
            filteredMetrics: {},
            loadingFilteredMetrics: false,
            reload: 0,
        };
    },
    watch: {
        metricsGranularity: {
            async handler() {
                await this.filterMetrics();
            },
            immediate: true,
        },
    },
    methods: {
        prettifyMetricName(metricName: string) {
            let prettified = metricName.replace(/Last\d{1,2}[mh]$/i, "").replace(/([a-z])([A-Z])/g, "$1 $2");
            return prettified.charAt(0).toUpperCase() + prettified.toLocaleLowerCase().slice(1);
        },
        async filterMetrics() {
            this.filteredMetrics = {};
            if (!this.metrics || !Object.keys(this.metrics).length) return;
            this.loadingFilteredMetrics = true;
            let timeToSleep = Math.random() * (1200 - 500) + 500;
            await new Promise((r) => setTimeout(r, timeToSleep));
            for (const [serviceName, data] of Object.entries(this.metrics)) {
                let serviceMetric = (data as any).SpecializedInformation;
                if (!serviceMetric) continue;
                let tempFilteredMetrics: {};
                if (this.metricsGranularity == 0) {
                    tempFilteredMetrics = Object.keys(serviceMetric)
                        .filter((key) => /[a-z]5m$/i.test(key))
                        .reduce((obj, key) => {
                            obj[key] = serviceMetric[key];
                            return obj;
                        }, {});
                } else if (this.metricsGranularity == 1) {
                    tempFilteredMetrics = Object.keys(serviceMetric)
                        .filter((key) => /15m/i.test(key))
                        .reduce((obj, key) => {
                            obj[key] = serviceMetric[key];
                            return obj;
                        }, {});
                } else if (this.metricsGranularity == 2) {
                    tempFilteredMetrics = Object.keys(serviceMetric)
                        .filter((key) => /30m/i.test(key))
                        .reduce((obj, key) => {
                            obj[key] = serviceMetric[key];
                            return obj;
                        }, {});
                } else if (this.metricsGranularity == 3) {
                    tempFilteredMetrics = Object.keys(serviceMetric)
                        .filter((key) => /1h/i.test(key))
                        .reduce((obj, key) => {
                            obj[key] = serviceMetric[key];
                            return obj;
                        }, {});
                }
                let noTimeMetrics = Object.keys(serviceMetric)
                    .filter((key) => !/5m|15m|30m|1h|isPaused/i.test(key))
                    .reduce((obj, key) => {
                        obj[key] = serviceMetric[key];
                        return obj;
                    }, {});
                this.filteredMetrics[serviceName] = { ...tempFilteredMetrics, ...noTimeMetrics };
            }
            this.loadingFilteredMetrics = false;
        },
        pauseServiceEnabled(metrics: any) {
            return metrics.HostInformation.ServiceType == "RemoteMessageController";
        },
        killServiceEnabled(metrics: any) {
            return metrics.HostInformation.ServiceType != "ManagementService" && metrics.HostInformation.ServiceType != "RemoteMessageController";
        },
        displayPauseDialog(serviceName: string) {
            this.pauseDialogServiceName = serviceName;
            this.showPauseDialog = true;
        },
        displayKillDialog(serviceName: string) {
            this.killDialogServiceName = serviceName;
            this.showKillDialog = true;
        },
        async killService(serviceName: string) {
            this.loadingControlService = true;
            try {
                let response: ApiGenericResponse = await new GetDataFlowKillServiceCommand(serviceName).execute();
                this.showKillDialog = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.$emit("reload");
                } else {
                    this.showControlServiceError = serviceName;
                    this.controlServiceError = this.$t("dataFlow.controlServiceError", { action: "killing", error: response.message });
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowKillServiceCommand request ", e);
            }
            this.loadingControlService = false;
        },
        async pauseService(serviceName: string) {
            this.loadingControlService = true;
            try {
                let response: ApiGenericResponse = await new GetDataFlowPauseServiceCommand(serviceName).execute();
                this.showPauseDialog = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.$emit("reload");
                } else {
                    this.showControlServiceError = serviceName;
                    this.controlServiceError = this.$t("dataFlow.controlServiceError", { action: "pausing", error: response.message });
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowPauseServiceCommand request ", e);
            }
            this.loadingControlService = false;
        },
        async resumeService(serviceName: string) {
            this.loadingControlService = true;
            try {
                let response: ApiGenericResponse = await new GetDataFlowResumeServiceCommand(serviceName).execute();
                this.showPauseDialog = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.$emit("reload");
                } else {
                    this.showControlServiceError = serviceName;
                    this.controlServiceError = this.$t("dataFlow.controlServiceError", { action: "pausing", error: response.message });
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowResumeServiceCommand request ", e);
            }
            this.loadingControlService = false;
        },
    },
    mounted() {
        const self = this;
        setInterval(function () {
            self.reload += 1;
        }, 60 * 1000);
    },
});
